import styled from "styled-components";
import { pxToRem } from "../../styles/utils";

export const MetricsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: ${pxToRem(35)};
  margin: ${pxToRem(15)} 0 ${pxToRem(22.5)};
`;

export const Metric = styled.div`
  display: inline-flex;
  align-items: baseline;
  gap: ${pxToRem(5)};
  color: ${({ theme }) => theme.colors.inkSoft};
  font-size: ${pxToRem(18)};
  font-weight: 400;

  strong {
    color: ${({ theme }) => theme.colors.ink};
    font-weight: 600;
  }
`;
